import React from 'react';
import { Provider } from 'react-redux';
import { ErrorReporting } from 'mm-ui-components';
import { Store } from 'redux';
import { ErrorReporter } from '../errorReporting/errorReporter.type';
import { AppState, AppActions } from '../store/initialStateRegistration';

interface PageProps {
    store: Store<AppState, AppActions>;
    errorProvider: ErrorReporter;
}

export const Page: React.FunctionComponent<PageProps> = ({ store, children, errorProvider }) => {
  return (
    <Provider store={store}>
      <ErrorReporting.Provider value={errorProvider}>
        {children}
      </ErrorReporting.Provider>
    </Provider>
);
};
